import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon-o-attention.svg'


const _withScopeId = n => (_pushScopeId("data-v-82af4a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"2px","transform":"translateY(2px)"},
  src: _imports_0
}, null, -1))
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_3 = {
  class: "from",
  style: {"width":"150px"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"display":"flex","justify-content":"center"} }

import { ref, computed, watch, CSSProperties } from 'vue';
import { getGaptcha } from '../loginApi';
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
interface fromType {
  label: string;
  value: string;
  type?: string;
  style?: CSSProperties;
  placeholder?: string;
  maxlength?: string | number;
  tipLabel?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  props: {
  fromList: { type: Array as () => Array<fromType>, required: true },
  visible: { type: Boolean, required: true, default: false },
  title: { type: String, required: false, default: '' },
  code: { type: Boolean, required: false, default: false },
  codeParams: { type: String, required: false, default: '3' },
  loading: { type: Boolean, required: false, default: false },
  outLoading: { type: Boolean, required: false, default: false },
  showClose: { type: Boolean, required: false, default: true }
},
  emits: ['update:visible', 'handleSave', 'handleLoginOut'],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const { t } = useI18n();
const store = useStore();




const gaptchaImg = ref('');
// 初始化  获取验证码
const init = () => {
  getGaptcha(props.codeParams).then((res) => {
    gaptchaImg.value = window.URL.createObjectURL(res);
  });
};

const dialogShow = computed({
  get: () => props.visible,
  set: (val: boolean) => emit('update:visible', val),
});
const params = ref<any>({});

const handleSave = () => {
  if (props.code && !params.value.gaptchaCode)
    return ElMessage.error(t('login.input') + t('login.gaptcha').toLowerCase());
  if (props.loading) return;
  emit('handleSave', params.value);
};

const handleLoginOut = () => {
  if (props.outLoading) return;
  emit('handleLoginOut');
}

watch(dialogShow, (value) => {
  if (value) {
    params.value = {};
    if (props.code) init();
  }
});

const widthClass = computed(() => store.getters.getLanguageValue == 'en' ? 'widthEn' : 'WidthNormol');

__expose({
  init,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogShow).value = $event)),
    title: props.title,
    width: "720px",
    "close-on-click-modal": false,
    class: "elDialogCommonCss",
    "show-close": __props.showClose
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.fromList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "from",
          key: item.value
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(widthClass.value),
            style: _normalizeStyle(item.style || {})
          }, [
            _createTextVNode(_toDisplayString(item.label) + " ", 1),
            (item.tipLabel)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: item.tipLabel,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 2
                }, 1032, ["content"]))
              : _createCommentVNode("", true)
          ], 6),
          _createVNode(_component_el_input, {
            modelValue: params.value[item.value],
            "onUpdate:modelValue": ($event: any) => ((params.value[item.value]) = $event),
            class: "w-50 m-2 inputbox",
            size: "large",
            placeholder: item.placeholder||_ctx.$t('login.input') + item.label.toLowerCase(),
            type: item.type ? item.type : 'text',
            maxlength: item.maxlength,
            "show-password": item.type == 'password' ? true : false
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "type", "maxlength", "show-password"])
        ]))
      }), 128)),
      (props.code)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: params.value.gaptchaCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((params.value.gaptchaCode) = $event)),
                class: "w-50 m-2 inputbox",
                size: "large",
                placeholder: _ctx.$t('login.gaptcha')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("img", {
              src: gaptchaImg.value,
              style: {"height":"40px","width":"120px","margin-left":"24px","padding-top":"5px"},
              class: "pointer",
              alt: "",
              srcset: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (init()))
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (!__props.showClose)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "enter",
              style: {"background":"rgb(235, 235, 235)","color":"#575757"},
              onClick: handleLoginOut
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('login.logout')), 1),
              (props.outLoading)
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    class: "el-icon is-loading",
                    style: {"margin-right":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Loading)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "enter",
          onClick: handleSave
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('login.confirm')), 1),
          (props.loading)
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "el-icon is-loading",
                style: {"margin-left":"5px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Loading)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "show-close"]))
}
}

})